<template>
<div class="page-form">
    <img class="logo" :src="getLogo()" />
    <h2 class="title">{{ sessionData.user }}</h2>

    <div v-if="sessionData.price >= 0 && !sessionData.payed" class="price">
        <span v-if="sessionData.price === 0" class="user-payed-free">{{ texts.free }}</span>
        <span v-else class="user-payed">
            {{ texts.price }}: {{ sessionData.price }} {{ sessionData.currency }}
            <br>
            <b-tag v-if="sessionData.payed" type="is-success">{{ texts.paid }}</b-tag>
            <b-tag v-else type="is-warning">{{ texts.unpaid }}</b-tag>
        </span>
    </div>

    <div id="pay"></div>

    <template v-if="!sessionData.price || sessionData.payed">

        <template v-if="!sessionOnTime && sessionData.start && !allowAccess">
            <p v-if="!isToday">{{ texts.visitScheduled }}</p>
            <p v-if="!isToday">{{ formatDate(sessionData.start) }}</p>
            <br>
            <p>{{ texts.accessWithin }}</p>
            <p style="font-weight:700" v-if="refreshTime">{{ getTimeUntilVisit(sessionData.start) }}</p>
            <b-icon
                class="join-icon-parent"
                pack="fas"
                :icon="isToday ? 'exclamation-circle' : 'clock'"
                custom-class="join-icon"
            />
            <p v-if="isToday">{{ texts.stillWaiting }}</p>
        </template>

        <template v-if="sessionOnTime">
            <p>{{ texts.notificationAvailable }}</p>
            <button class="button is-success auth-check">
                <b-icon
                    pack="fas"
                    icon="check">
                </b-icon>
            </button>
            <p class="auth-msg">{{ texts.authorizedAccess }}</p>
        </template>

        <template v-if="!sessionOnTime && allowAccess">
            <p>{{ texts.visitStart }}</p>
            <p style="font-weight:700" v-if="refreshTime">{{ getTimeUntilVisit(sessionData.start) }}</p>
            <button class="button is-warning auth-check">
                <b-icon
                    pack="fas"
                    icon="check">
                </b-icon>
            </button>
            <p class="auth-msg">{{ texts.authorizedAccess }}</p>
        </template>


        <template v-if="!sessionData.start">
            <p>{{ texts.notificationNotAvailable }}</p>
            <button class="button is-danger auth-check auth-check-disabled">
                <b-icon
                    custom-class="ban-icon"
                    pack="fas"
                    icon="ban">
                </b-icon>
            </button>
            <p class="auth-msg">{{ texts.unauthorizedAccess }}</p>
        </template>

        <b-field
            v-if="sessionData.pin && allowAccess"
            class="pin-input"
        >
            <b-input
                v-model="pin"
                :placeholder="texts.pin"
                size="is-medium"
            />
        </b-field>

        <b-field
            v-if="sessionData.userId && allowAccess"
            class="pin-input"
        >
            <b-input
                v-model="userId"
                :placeholder="texts.userId"
                size="is-medium"
            />
        </b-field>

    </template>

    <a
        v-show="sessionData.payed !== false"
        class="button is-success is-fullwidth btn-action"
        :disabled="(!pin && sessionData.pin) || !allowAccess || (!userId && sessionData.userId)"
        @click="connect()"
    >
        {{ texts.connect }}
    </a>
</div>
</template>

<script>
import moment from 'moment';
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'Join',
    mixins: [ Utils ],
    data () {
        return {
            config: {},
            texts: {},
            session: null,
            sessionData: {},
            pin: null,
            userId: null,
            accept: null,
            sessionOnTime: false,
            refreshTime: true,
            isToday: false,
            allowAccess: false,
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        localStorage.removeItem('username');
        localStorage.removeItem('session');
        if (!this.$route.params.session) this.$router.push('/');
        this.session = this.$route.params.session;
        this.accept = this.$route.params.accept;
        this.getSession();
    },
    methods: {
        connect() {
            if (this.sessionData.pin && !this.pin) return;
            if (this.sessionData.userId && !this.userId) return;
            if (!this.allowAccess) return;
            if (this.sessionData.pin && this.sessionData.pin !== this.pin) {
                this.$buefy.toast.open({ message: this.texts.invalidPin, type: 'is-danger', position: 'is-bottom' });
                return;
            }
            if (this.sessionData.userId && this.sessionData.userId !== this.userId) {
                this.$buefy.toast.open({ message: this.texts.invalidUserId, type: 'is-danger', position: 'is-bottom' });
                return;
            }
            localStorage.setItem('username', this.sessionData.user);
            localStorage.setItem('session', this.session);
            this.$router.push('/call');
        },
        getSession() {
            HealthCareService.getSession(this.session)
                .then(res => {
                    this.sessionData = res.data;
                    this.sessionOnTime = (moment() >= moment(this.sessionData.start));
                    this.isToday = moment().isSame(moment(this.sessionData.start), 'day');
                    this.checkAllowAccess(this.sessionData.start);
                    if (this.sessionData.payed === false) {
                        HealthCareService.getConfigPayment()
                            .then(res => {
                                const paypalId = res.data['paypal-client-id'];
                                const url = `https://www.paypal.com/sdk/js?currency=${this.sessionData.currency}&disable-funding=credit&client-id=${paypalId}`;
                                this.$loadScript(url)
                                    .then(() => {
                                        paypal.Buttons({
                                            style: {
                                                layout:  'vertical',
                                                color:   'silver',
                                                tagline: false,
                                            },
                                            createOrder: (data, actions) => {
                                                return new Promise((resolve, reject) => {
                                                    HealthCareService.paypalCreateOrder(this.session)
                                                        .then(res => {
                                                            resolve(res.data.orderID);
                                                        })
                                                        .catch(error => {
                                                            const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                                                            this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                                                        })
                                                })
                                            },
                                            onApprove: data => {
                                                return new Promise((resolve, reject) => {
                                                    HealthCareService.paypalUpdateOrder(this.session)
                                                        .then(res => {
                                                            if (res && res.data && res.data.payed) {
                                                                this.$buefy.toast.open({ message: this.texts.paymentSent, type: 'is-success', position: 'is-bottom' });
                                                                window.location.reload();
                                                                resolve(res);
                                                            }
                                                        })
                                                        .catch(error => {
                                                            const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                                                            this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                                                        })
                                                })
                                            },
                                            onCancel: data => {},
                                            onError: error => {
                                                const err = error || 'Error';
                                                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                                                window.location.reload();
                                            },
                                        }).render('#pay');
                                    });
                            })
                            .catch(error => {
                                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                            })
                    }
                    else if (this.allowAccess && this.sessionData.autoConnect && this.accept !== 'accept') this.connect();
                })
        },
        formatDate(date) {
            const format = `${this.config.dateFormat || 'DD/MM/YYYY'} ${this.config.timeFormat || 'HH:mm'}`;
            return moment(date).format(format);
        },
        checkAllowAccess(start) {
            const now = moment();
            const diff = moment(start).diff(now);
            const diffDt = moment.duration(diff);
            const days = diffDt.days();
            const hours = diffDt.hours();
            const mins = diffDt.minutes();
            const secs = diffDt.seconds();
            const secsUntilAppoinment = days * 24 * 60 * 60 + hours * 60 * 60 + mins * 60 + secs;
            if (secsUntilAppoinment <= (this.config.timeAllowedBeforeAppointment || 15 * 60)) this.allowAccess = true;
            return { days, hours, mins, secs };
        },
        getTimeUntilVisit(start) {
            const { days, hours, mins, secs } = this.checkAllowAccess(start);
            let res = '';
            if (days > 1) res += `${days} ${this.texts.duration.days} `;
            else if (days > 0) res += `${days} ${this.texts.duration.day} `;
            if (hours > 1) res += `${hours} ${this.texts.duration.hours} `;
            else if (hours > 0) res += `${hours} ${this.texts.duration.hour} `;
            if (days === 0 && mins > 1) res += `${mins} ${this.texts.duration.mins} `;
            else if (days === 0 &&  mins > 0) res += `${mins} ${this.texts.duration.min} `;
            if (days === 0 && hours === 0 && secs > 1) res += `${secs} ${this.texts.duration.secs}`;
            else if (days === 0 && hours === 0 && secs > 0) res += `${secs} ${this.texts.duration.sec}`;
            if (secs < 0) window.location.reload();
            setTimeout(() => {
                this.refreshTime = false;
                this.$nextTick(() => {
                    this.refreshTime = true;
                });
            }, 1000);
            return res;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
}
.logo {
    max-width: 95%;
    max-height: 180px;
    @media (max-height: 450px) {
        display: none;
    }
}
.title {
    margin-top: 25px;
}
.btn-action {
    height: 60px;
    font-size: 1.3em;
    bottom: 20px;
    width: auto;
    top: 0px;
    width: 100%;
    max-width: 500px;
    margin-bottom: 15px;
    margin-top: 15px;
}
.price {
    font-size: 1.1em;
    margin-bottom: 20px;
}
.auth-check {
    margin-top: 30px;
    margin-bottom: 30px;
    border-radius: 32px;
    height: 64px;
    width: 64px;
    font-size: 40px;
    cursor: auto;
    @media (max-height: 450px) {
        display: none;
    }
}
.auth-check:focus {
    box-shadow: none !important;
}
.auth-check-disabled, .auth-check-disabled:focus, .auth-check-disabled:hover {
    background: white;
    color: #ff3860;
    height: auto;
    width: auto;
    @media (max-height: 450px) {
        display: inline;
    }
}
.auth-msg {
    font-weight: 700;
}
.join-icon-parent {
    color: gray;
    height: 48px;
    width: 48px;
    margin-top: 15px;
    margin-bottom: 15px;
}
.pin-input {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Join.vue